"use client"

import VenueMenusClient from "./VenueMenusClient"
import { RESTAURANT_VENUE_CONFIG } from "../lib/venue-menus-client/venueMenusClientConfig"

const RestaurantsMenusClient = () => <VenueMenusClient config={RESTAURANT_VENUE_CONFIG} />

export default RestaurantsMenusClient
